export interface Ebook {
  id: string;
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  coverImage: string;
  pages: number;
  category: string;
  topics: string[];
  formUrl: string;
  downloadUrl: string;
  badge?: string;
}

export const ebooks: Ebook[] = [
  {
    id: 'ebook-ergonomia-nr17',
    slug: 'guia-nr17-ergonomia-escritorio',
    title: 'Guia Prático NR-17: Ergonomia no Escritório',
    subtitle: 'Tudo o que sua empresa precisa saber para estar em conformidade e evitar multas e ações trabalhistas',
    description: 'Um guia completo e direto ao ponto sobre a NR-17. Aprenda o que a norma exige para cadeiras, mesas, monitores e iluminação — com checklist prático para aplicar imediatamente no seu escritório em Caruaru.',
    coverImage: '/media/ia/0282.webp',
    pages: 14,
    category: 'Ergonomia & Compliance',
    badge: 'Mais Baixado',
    topics: [
      'O que é a NR-17 e quem é obrigado a cumprir',
      'Requisitos mínimos para cadeiras e mesas',
      'Como posicionar monitores corretamente',
      'Multas e riscos de ações trabalhistas',
      'Checklist de conformidade por posto de trabalho',
      'Quanto custa adequar seu escritório',
    ],
    formUrl: 'https://readdy.ai/api/form/d7kklt263r16okiqpo2g',
    downloadUrl: '/ebooks/nr17-ergonomia.html',
  },
  {
    id: 'ebook-escritorio-zero',
    slug: 'montando-escritorio-do-zero',
    title: 'Montando seu Escritório do Zero',
    subtitle: 'O guia honesto que ninguém te deu — da cadeira de R$ 300 ao escritório que impressiona clientes',
    description: 'Da escolha da cadeira certa ao layout da recepção que fecha contratos: tudo que você precisa saber antes de gastar qualquer centavo no seu escritório. Inclui estimativas de investimento, armadilhas comuns e o caso real da cadeira que quebrou no meio de uma reunião.',
    coverImage: '/media/ia/0283.webp',
    pages: 13,
    category: 'Planejamento & Design',
    badge: 'Novo',
    topics: [
      'As 3 perguntas que definem tudo antes de comprar',
      'Por que a cadeira de R$ 300 sai mais cara no final',
      'NR-17: o risco jurídico que todo empresário ignora',
      'A recepção que fecha contratos antes de você falar',
      'Quanto investir e em qual ordem de prioridade',
      'Estimativa real de investimento por porte de empresa',
    ],
    formUrl: 'https://readdy.ai/api/form/d7kkltq63r16okiqpo30',
    downloadUrl: '/ebooks/escritorio-do-zero.html',
  },
  {
    id: 'ebook-recepcao-vende',
    slug: 'recepcao-que-vende',
    title: 'A Recepção que Vende: Transforme sua Sala de Espera em Argumento de Venda',
    subtitle: 'Como criar uma experiência de espera que fideliza clientes, gera avaliações 5 estrelas e fecha contratos maiores',
    description: 'Ninguém quer esperar. Mas quando a recepção é bem projetada, o cliente espera e ainda sai satisfeito. Aprenda como montar uma recepção que comunica profissionalismo, conquista clientes e gera avaliações positivas no Google.',
    coverImage: '/media/ia/0284.webp',
    pages: 11,
    category: 'Experiência do Cliente',
    topics: [
      'Por que a recepção impacta sua nota no Google',
      'A estação de hospitalidade: café, água, carregador',
      'Cadeiras, iluminação e acústica: o que realmente importa',
      'O canto de reunião informal que fecha contratos',
      'Checklist completo por tipo de negócio',
      'Casos reais: antes e depois de recepções reformadas',
    ],
    formUrl: 'https://readdy.ai/api/form/d7kkltq63r16okiqpo3g',
    downloadUrl: '/ebooks/recepcao-que-vende.html',
  },
  {
    id: 'ebook-advocacia',
    slug: 'escritorio-advocacia-que-fecha-contratos',
    title: 'O Escritório de Advocacia que Fecha Contratos',
    subtitle: 'A psicologia do ambiente e como mobiliário de qualidade aumenta o valor percebido dos seus honorários',
    description: 'Advogados vendem confiança. E a confiança começa antes de você falar uma palavra. Aprenda como cores, móveis, iluminação e layout comunicam autoridade e ajudam a fechar contratos maiores — com cases reais de escritórios em Pernambuco.',
    coverImage: '/media/ia/0285.webp',
    pages: 12,
    category: 'Escritório de Advocacia',
    topics: [
      'Psicologia das cores para escritórios jurídicos',
      'A mesa do advogado: o trono da autoridade',
      'A cadeira do cliente que prolonga a reunião',
      'Sala de reunião que fecha contratos maiores',
      'Biblioteca e estante: o argumento visual do conhecimento',
      'Quanto investir para dobrar o valor percebido',
    ],
    formUrl: 'https://readdy.ai/api/form/d7kkltq63r16okiqpo40',
    downloadUrl: '/ebooks/advocacia-contratos.html',
  },
  {
    id: 'ebook-escolar-2026',
    slug: 'escola-do-futuro-moveis-escolares-2026',
    title: 'Escola do Futuro: Mobiliário Escolar que Retém Alunos',
    subtitle: 'Como ambientes modernos e espaços inovadores aumentam matrículas, retêm alunos e transformam a percepção dos pais',
    description: 'O guia completo para gestores escolares: entenda por que os pais decidem a matrícula pelo que veem, como cadeiras velhas custam alunos, e como criar Salas Maker, laboratórios e ambientes modernos que nenhuma escola concorrente tem.',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20school%20classroom%202026%20innovative%20furniture%20ergonomic%20chairs%20students%20learning%20maker%20space%20robotics%20laboratory%20bright%20colorful%20educational%20environment%20Brazil%20contemporary%20design&width=600&height=800&seq=ebook5escolar&orientation=portrait',
    pages: 14,
    category: 'Educação Escolar',
    badge: 'Novo',
    topics: [
      'Por que os pais decidem a matrícula pelo que veem',
      'O impacto de cadeiras velhas na retenção de alunos',
      'Sala Maker, robótica e inovação: o diferencial que fecha matrícula',
      'Sala de aula moderna em 2026: o que entregar',
      'Checklist de modernização anual para escolas',
      'Quanto investir e por onde começar',
    ],
    formUrl: 'https://readdy.ai/api/form/d7kmnkf44bvd703c96f0',
    downloadUrl: '/ebooks/moveis-escolares-2026.html',
  },
  {
    id: 'ebook-clinicas',
    slug: 'clinicas-ambiente-que-cura',
    title: 'O Ambiente que Cura: Mobiliário para Clínicas Médicas',
    subtitle: 'Como criar uma clínica em conformidade com a ANVISA que transmite confiança e transforma a experiência do paciente',
    description: 'Guia completo para médicos e gestores: entenda os requisitos sanitários do mobiliário, como projetar recepção, consultório e sala de coleta para aumentar a satisfação do paciente e as avaliações no Google.',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20ebook%20cover%20design%20medical%20clinic%20healthcare%20interior%20guide%20teal%20dark%20background%20clean%20minimalist%20modern%20hospital%20furniture%20patient%20experience%20Brazilian%20health%20guide%20workbook%20typography&width=600&height=800&seq=ebook6clinicas&orientation=portrait',
    pages: 13,
    category: 'Clínicas Médicas',
    badge: 'Novo',
    topics: [
      'Por que o ambiente impacta o diagnóstico e o tratamento',
      'ANVISA: o que o mobiliário precisa atender',
      'A recepção que acalma antes do atendimento',
      'Consultório: o ambiente que abre o paciente',
      'Sala de coleta: funcionalidade e segurança',
      'Checklist de conformidade sanitária completo',
    ],
    formUrl: 'https://readdy.ai/api/form/d7ohgr8ltb4nd0kphff0',
    downloadUrl: '/ebooks/clinicas-ambiente-que-cura.html',
  },
  {
    id: 'ebook-hotelaria',
    slug: 'hotelaria-5-estrelas',
    title: 'Do Check-in ao Check-out 5 Estrelas',
    subtitle: 'Como o mobiliário certo transforma hóspedes em avaliações 5 estrelas no Booking e aumenta a diária média',
    description: 'Guia completo para hoteleiros: entenda por que o mobiliário define a nota do hotel, como projetar quartos, recepção e café da manhã para gerar avaliações positivas e aumentar a diária média.',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20ebook%20cover%20design%20luxury%20hotel%20hospitality%20interior%20guide%20dark%20warm%20gold%20tones%20premium%20bedroom%20furniture%20five%20stars%20experience%20Brazilian%20hospitality%20guide%20workbook%20typography&width=600&height=800&seq=ebook7hotelaria&orientation=portrait',
    pages: 13,
    category: 'Hotelaria',
    badge: 'Novo',
    topics: [
      'Por que o mobiliário define a nota no Booking',
      'O quarto: cabeceira, criados-mudos e armário',
      'Recepção e lobby: a primeira impressão',
      'Café da manhã: onde as avaliações são escritas',
      'Materiais que resistem ao uso intenso',
      'ROI da reforma: quanto investir para subir de categoria',
    ],
    formUrl: 'https://readdy.ai/api/form/d7ohgroltb4nd0kphffg',
    downloadUrl: '/ebooks/hotelaria-5-estrelas.html',
  },
  {
    id: 'ebook-academia',
    slug: 'academia-ambiente-que-converte',
    title: 'A Academia que Converte e Retém Alunos',
    subtitle: 'Como o ambiente impacta a taxa de matrícula, a retenção de alunos e o faturamento mensal da sua academia',
    description: 'Guia completo para donos de academia: entenda por que alunos cancelam por causa do ambiente, como projetar recepção, vestiários e sala de avaliação para aumentar a retenção e o faturamento.',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20ebook%20cover%20design%20gym%20fitness%20academy%20interior%20guide%20dark%20red%20black%20tones%20modern%20locker%20room%20reception%20performance%20sports%20Brazilian%20fitness%20guide%20workbook%20typography&width=600&height=800&seq=ebook8academia&orientation=portrait',
    pages: 12,
    category: 'Academia & Fitness',
    badge: 'Novo',
    topics: [
      'Por que alunos cancelam por causa do ambiente',
      'A recepção que fecha matrículas antes do salão',
      'Vestiários: o ambiente que faz o aluno renovar',
      'Sala de avaliação: onde a fidelização começa',
      'Materiais resistentes ao ambiente úmido',
      'Quanto investir para aumentar a retenção',
    ],
    formUrl: 'https://readdy.ai/api/form/d7ohgs8ltb4nd0kphfg0',
    downloadUrl: '/ebooks/academia-ambiente-que-converte.html',
  },
  {
    id: 'ebook-imobiliaria',
    slug: 'imobiliaria-escritorio-que-fecha',
    title: 'A Imobiliária que Fecha Negócios',
    subtitle: 'Como o ambiente da sua imobiliária vende o sonho antes de mostrar o primeiro imóvel',
    description: 'Guia completo para donos e gestores de imobiliárias: entenda como o escritório impacta a percepção de valor dos imóveis, como projetar recepção, sala de atendimento e área dos corretores para fechar mais negócios.',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20ebook%20cover%20design%20real%20estate%20agency%20office%20interior%20guide%20dark%20navy%20sophisticated%20modern%20reception%20meeting%20room%20property%20sales%20Brazilian%20real%20estate%20guide%20workbook%20typography&width=600&height=800&seq=ebook9imobiliaria&orientation=portrait',
    pages: 12,
    category: 'Imobiliárias',
    badge: 'Novo',
    topics: [
      'O ambiente que vende o sonho antes do imóvel',
      'A recepção que cria desejo antes da reunião',
      'Sala de atendimento com privacidade acústica',
      'TV de apresentação: o argumento visual',
      'Área dos corretores que aumenta produtividade',
      'Quanto investir para fechar negócios maiores',
    ],
    formUrl: 'https://readdy.ai/api/form/d7ohgsoltb4nd0kphfgg',
    downloadUrl: '/ebooks/imobiliaria-escritorio-que-fecha.html',
  },
  {
    id: 'ebook-farmacia',
    slug: 'farmacia-layout-que-vende',
    title: 'O Layout da Farmácia que Vende Mais',
    subtitle: 'Como gôndolas estratégicas e iluminação adequada aumentam o ticket médio e a fidelização dos clientes',
    description: 'Guia completo para farmacêuticos e gestores: entenda como o layout impacta o faturamento, como posicionar gôndolas e produtos para aumentar as vendas por impulso e como projetar a área de dermocosméticos.',
    coverImage: 'https://readdy.ai/api/search-image?query=professional%20ebook%20cover%20design%20pharmacy%20drugstore%20interior%20guide%20dark%20green%20clean%20modern%20gondola%20shelves%20products%20retail%20layout%20Brazilian%20pharmacy%20guide%20workbook%20typography&width=600&height=800&seq=ebook10farmacia&orientation=portrait',
    pages: 13,
    category: 'Farmácias',
    badge: 'Novo',
    topics: [
      'Por que o layout impacta diretamente o faturamento',
      'As zonas da farmácia e como cada uma gera receita',
      'A regra das alturas nas gôndolas',
      'Balcão de atendimento e dispensário',
      'Dermocosméticos: a categoria de maior margem',
      'Conformidade ANVISA e checklist completo',
    ],
    formUrl: 'https://readdy.ai/api/form/d7ohgt8ltb4nd0kphfh0',
    downloadUrl: '/ebooks/farmacia-layout-que-vende.html',
  },
];
